import styled, { css } from "styled-components";

export const ModalBackground = styled.div`
  position: fixed;
  width: 110vw;
  height: 110vh;
  top: 0;
  left: 0;
  background: ${(props) => props.theme.colors.black}b2;
  z-index: 9998 !important;
`;

export const Modal = styled.div<{
  backGround?: "white" | "stop";
  size?: string;
}>`
  position: absolute;
  display: grid;
  width: 100%;
  max-width: 80vw;
  max-height: 80vh;
  top: 50%;
  left: 50%;
  padding: 30px;
  border-radius: 8px;
  box-shadow: ${(props) => props.theme.shadow.modal};
  grid-template-rows: 40px auto;
  transform: translate(-50%, -50%);
  gap: 30px;
  z-index: 9999;

  ${(props) =>
    props.backGround === "white" &&
    css`
      background: ${(props: any) => props.theme.colors.white};
    `}

  ${(props) =>
    props.backGround === "stop" &&
    css`
      background: ${(props: any) => props.theme.colors.dotted};
    `}


  // 모바일 환경(640px 이하) 설정
  @media (max-width: 640px) {
    width: ${(props) =>
      props.size === "md" ? "calc(100% - 82px)" : "calc(100% - 32px)"};
    max-width: 100%;
    padding: 20px;
    gap: 20px;
  }
`;

export const ModalTit = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    width: 100%;
    font-size: 1.8rem;
    font-weight: 600;
  }

  &.center {
    justify-content: center;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
  }
`;

export const ModalContent = styled.div`
  overflow: auto;

  & > div {
    & + div {
      margin-top: 30px;
    }

    & + button {
      margin-top: 30px;
    }
  }
`;

export const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;

  // 모바일 환경(640px 이하) 설정
  @media (max-width: 640px) {
    gap: 10px;
  }
`;

export const ModalFooterButton = styled.div`
  margin-top: 10px;
`;

export const InputButtonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 60px;
  gap: 5px;

  // 모바일 환경(640px 이하) 설정
  @media (max-width: 640px) {
    align-items: end;

    button {
      height: 30px !important;
    }
  }
`;

export const ExistModal = styled.div`
  letter-spacing: -1px;
`;
